var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReservationBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B5AE3980-7FBD-4B87-BE32-25133E695B8A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Aanpassingen",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    transform: "translate(-57.000000, -22.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_reserveren",
    transform: "translate(57.000000, 22.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2307656,6.04007813 C21.6835781,6.04007813 22.0694531,6.36853125 22.1419688,6.81548438 L22.1419688,6.81548438 L23.9881406,18.2016563 C24.0315,18.4687969 23.955375,18.7414688 23.7799688,18.9475781 C23.6045625,19.1536406 23.3475469,19.2724219 23.0769375,19.2724219 L23.0769375,19.2724219 L0.923109375,19.2724219 C0.652453125,19.2724219 0.395484375,19.1537344 0.220078125,18.9475781 C0.04471875,18.7414219 -0.03140625,18.4687969 0.01190625,18.2016563 L0.01190625,18.2016563 L1.85807813,6.81548438 C1.93059375,6.36853125 2.3165625,6.04007813 2.76928125,6.04007813 L2.76928125,6.04007813 Z M2.773875,12.7020938 L2.00789063,17.4263438 L3.53985938,17.4263438 L2.773875,12.7020938 Z M20.4453281,7.88629688 L3.86329688,7.88629688 L5.410125,17.4263438 L21.9921563,17.4263438 L20.4453281,7.88629688 Z M18.4615781,11.7332344 C18.9713438,11.7332344 19.3846406,12.1465312 19.3846406,12.6562969 C19.3846406,13.1660625 18.9713438,13.5793594 18.4615781,13.5793594 L18.4615781,13.5793594 L7.38464063,13.5793594 C6.874875,13.5793594 6.46157813,13.1660625 6.46157813,12.6562969 C6.46157813,12.1465312 6.874875,11.7332344 7.38464063,11.7332344 L7.38464063,11.7332344 Z",
    id: "Combined-Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReservationBlack);
export default __webpack_public_path__ + "static/media/reservation-black.5cbbbe16b0dd5996a61c8b60c35a97f5.svg";
export { ForwardRef as ReactComponent };